
// 正式域名 
const DOMAIN_P = {
    auto: '//souapi.pcauto.com.cn',
    //综合经销商信息分离接口
    price: '//price.pcauto.com.cn',
    //综合页行家分离接口
    hj: 'https://hj.pcauto.com.cn',
    //车系论坛信息
    bbs: 'https://bbs.pcauto.com.cn',
    //综合页无结果时的请求接口
    cmsTag: 'https://cms-api.pcauto.com.cn',
    // B端更换接口
    bTag: 'https://qdfront.pcauto.com.cn',
    // 网关
    gateway: 'https://c-gateway.pcauto.com.cn',
    mb: 'https://mrobot.pcauto.com.cn'
};
//测试域名
const DOMAIN_Q = {
    auto: "//qa-ks.pcauto.com.cn/",
    //综合经销商信息分离接口
    price: '//price.pcauto.com.cn',
    //综合页行家分离接口
    // hj: 'https://t-hj2.pcauto.com.cn',
    hj: '//hj.pcauto.com.cn',
    //车系论坛信息
    bbs: '//bbs.pcauto.com.cn',
    //综合页无结果时的请求接口
    cmsTag: '//cms-api.pcauto.com.cn',
    // B端更换接口
    // bTag: '//qa-front.pcauto.com.cn'
    bTag: 'https://qdfront.pcauto.com.cn',
    // 网关
    gateway: 'https://qa-gateway.pcauto.com.cn',
    mb: 'https://t-mrobot.pcauto.com.cn'
};
//开发域名
const DOMAIN_D = {
    auto: "//qa-ks.pcauto.com.cn/",
    //综合经销商信息分离接口
    price: '//price.pcauto.com.cn',
    //综合页行家分离接口
    // hj: '//dev84.pcauto.com.cn:8080',
    // hj: '//hj.pcauto.com.cn',
    hj: 'https://hj.pcauto.com.cn',
    //车系论坛信息
    bbs: 'https://bbs.pcauto.com.cn',
    //综合页无结果时的请求接口
    cmsTag: 'https://cms-api.pcauto.com.cn',
    // B端更换接口
    bTag: 'https://qdfront.pcauto.com.cn',
    // 网关
    gateway: 'https://qa-gateway.pcauto.com.cn',
    mb: 'https://t-mrobot.pcauto.com.cn'
};


export const env = process.env.VUE_APP_NODE_ENV
export const service = env == 'production' ? DOMAIN_P : env == 'qa' ? DOMAIN_Q : env == 'experience' ? DOMAIN_Q : DOMAIN_D
export const fetchPrefix = '/auto'

export const csidKey = env == 'production' ? 'common_session_id' : 'common_session_id1'

export const carsDefaultImgUrl = '//www1.pcauto.com.cn/wjb/201407/12090.jpg' //车系默认图
export const brandLogoDefaultImgUrl = '//www1.pcauto.com.cn/wjb/201407/6464.jpg' //logo默认图
export const bbsHeadDefaultImgUrl = '//bbs.pcauto.com.cn/images/auto/auto.jpg' //bbs论坛头部默认图
export const baikeHeadDefaultImgUrl = '//www1.pcauto.com.cn/wjb/201410/150100.jpg' //百科头部默认图
export const indexConditionDefaultImaUrl = '//www1.pcauto.com.cn/2010/price/img/slt/350x260.jpg' //条件选车默认图
export const indexTagDefaultImaUrl = '//www1.pcauto.com.cn/2010/price/img/slt/240x160.jpg' //标签词默认图



export default {
    env,
    fetchPrefix,
    service,
    csidKey,
    carsDefaultImgUrl,
    brandLogoDefaultImgUrl,
    bbsHeadDefaultImgUrl,
    baikeHeadDefaultImgUrl,
    indexConditionDefaultImaUrl,
    indexTagDefaultImaUrl
}
